module.exports = __webpack_public_path__ + "img/infoleft.b77c8482.png";